import classNames from "classnames";
import React from "react";
import { Icon } from "../icon";

// Should we rename this to HeaderListItem
// Should we make this a button, so it has the disabled state and we can use the :active css style
export const ListItem = (
	props: {
		activated?: boolean;
	} & React.HTMLProps<HTMLLIElement>,
) => {
	const { disabled, activated, children, ...rest } = props;

	const cssClass = classNames([
		"list-item",
		{
			"list-item--disabled": disabled,
			"list-item--activated": activated,
		},
	]);

	return (
		<li className={cssClass} {...rest}>
			{children}
		</li>
	);
};

ListItem.displayName = "ListItem";

const ListItemIcon = ({ className, ...restProps }: React.ComponentProps<typeof Icon>) => {
	const cssClass = classNames(["list-item__icon", className]);

	return <Icon className={cssClass} {...restProps} />;
};

ListItemIcon.displayName = "ListItemIcon";

const ListItemText = ({ className, ...restProps }: React.HTMLProps<HTMLSpanElement>) => {
	const cssClass = classNames(["list-item__text", className]);

	return <span className={cssClass} {...restProps} />;
};

ListItemText.displayName = "ListItemText";
